import React, { useState, useEffect } from "react";
import { CharacterSheet, createEmptyCharacterSheet } from "./data/characterSchema";
import { exportToMarkdown, exportToJSON, downloadFile } from "./utils/exporters";
import { InformacoesBasicas } from "./components/InformacoesBasicas";
import { AtributosSection } from "./components/AtributosSection";
import { ValoresDerivados } from "./components/ValoresDerivados";
import { ReinoCultivo } from "./components/ReinoCultivo";
import { RaizesEspirituais } from "./components/RaizesEspirituais";
import { Tecnicas } from "./components/Tecnicas";
import { Pericias } from "./components/Pericias";
import { VantagensDesvantagens } from "./components/VantagensDesvantagens";
import { EquipamentosInventario } from "./components/EquipamentosInventario";
import { OutrosCampos } from "./components/OutrosCampos";
import { Dominio } from "./components/Dominio";
import { Identidades } from "./components/Identidades";
import { Destino } from "./components/Destino";
import "./App.css";

const STORAGE_KEY = "cultivo-rpg-character-sheet";

function App() {
  const [character, setCharacter] = useState<CharacterSheet>(() => {
    // Carregar do localStorage se existir
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Erro ao carregar ficha salva:", e);
      }
    }
    return createEmptyCharacterSheet();
  });

  // Salvar automaticamente no localStorage sempre que houver mudanças
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(character));
  }, [character]);

  const handleExportMarkdown = () => {
    const md = exportToMarkdown(character);
    const filename = `${character.nomePersonagem || "ficha"}-${Date.now()}.md`;
    downloadFile(md, filename, "text/markdown");
  };

  const handleExportJSON = () => {
    const json = exportToJSON(character);
    const filename = `${character.nomePersonagem || "ficha"}-${Date.now()}.json`;
    downloadFile(json, filename, "application/json");
  };

  const handleNewCharacter = () => {
    if (window.confirm("Tem certeza que deseja criar uma nova ficha? A ficha atual será perdida.")) {
      setCharacter(createEmptyCharacterSheet());
    }
  };

  const handleLoadFromFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const content = e.target?.result as string;
        const loaded = JSON.parse(content);
        setCharacter(loaded);
        alert("Ficha carregada com sucesso!");
      } catch (error) {
        alert("Erro ao carregar ficha. Verifique se o arquivo é um JSON válido.");
        console.error(error);
      }
    };
    reader.readAsText(file);
    // Reset input
    event.target.value = "";
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1>Ficha de Personagem - Cultivo RPG 3d10x</h1>
        <div className="header-actions">
          <button onClick={handleNewCharacter} className="btn btn-secondary">
            Nova Ficha
          </button>
          <label className="btn btn-secondary">
            Carregar JSON
            <input
              type="file"
              accept=".json"
              onChange={handleLoadFromFile}
              style={{ display: "none" }}
            />
          </label>
          <button onClick={handleExportJSON} className="btn btn-primary">
            Exportar JSON
          </button>
          <button onClick={handleExportMarkdown} className="btn btn-primary">
            Exportar Markdown
          </button>
        </div>
      </header>

      <main className="app-main">
        <InformacoesBasicas character={character} onChange={setCharacter} />
        <AtributosSection character={character} onChange={setCharacter} />
        <ValoresDerivados character={character} onChange={setCharacter} />
        <ReinoCultivo character={character} onChange={setCharacter} />
        <RaizesEspirituais character={character} onChange={setCharacter} />
        <Tecnicas character={character} onChange={setCharacter} />
        <Dominio character={character} onChange={setCharacter} />
        <Identidades character={character} onChange={setCharacter} />
        <Destino character={character} onChange={setCharacter} />
        <Pericias character={character} onChange={setCharacter} />
        <VantagensDesvantagens character={character} onChange={setCharacter} />
        <EquipamentosInventario character={character} onChange={setCharacter} />
        <OutrosCampos character={character} onChange={setCharacter} />
      </main>

      <footer className="app-footer">
        <p>Ficha salva automaticamente no navegador</p>
      </footer>
    </div>
  );
}

export default App;
